import { useCallback, useState } from 'react';
import { readAffiliateChoice, writeAffiliateChoice } from '../utils/affiliateConsent';

/**
 * Tracks whether the user has opted in to affiliate-linked recommendations on
 * this device. Pure client-side state (localStorage) — reading it never hits
 * the network, so the product popup can gate instantly and the product-search
 * API is only ever called after `accept()`.
 */
export function useAffiliateConsent() {
  const [enabled, setEnabled] = useState<boolean>(() => readAffiliateChoice() === 'on');

  const accept = useCallback(() => {
    writeAffiliateChoice('on');
    setEnabled(true);
  }, []);

  return { enabled, accept };
}
